import script from "./PromoCodeTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./PromoCodeTable.vue?vue&type=script&setup=true&lang=ts"

import "./PromoCodeTable.vue?vue&type=style&index=0&id=6b137384&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b137384"]])

export default __exports__